import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {Observable} from 'rxjs';
import {Driver} from '@common-module/modelinterfaces/driver.model';
import {UrlImage} from '../../constants/url-image';
import {DriverManagementService} from '../../services/driver-management.service';
import { AsyncPipe } from "@angular/common";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {PermissionsSecurityService} from "../../services/permissions-security.service";
import {FeatureKey} from "@common-module/modelinterfaces/enums/feature-key";

@Component({
    selector: 'app-current-driver',
    templateUrl: './current-driver.component.html',
    imports: [
    AsyncPipe,
    MatIconButton,
    MatIcon,
    TranslateModule,
    MatButton
],
    styleUrls: ['./current-driver.component.scss', '../../../../../../common-module/src/lib/app-styles/dialog-common.scss']
})

export class CurrentDriverComponent implements OnInit {

  @Input() isCarousel = false;
  @Input() unitId: number;

  public readonly DEFAULT_AVATAR = UrlImage.DEFAULT_AVATAR;

  public driver$: Observable<Driver>;
  public isDriverAvailable: boolean = true;
  public isDriverEditAvailable: boolean = true;
  public isDriverAssignAvailable: boolean = true;

  constructor(private driverManagementService: DriverManagementService,
              private readonly permissionsSecurityService: PermissionsSecurityService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['unitId']) {
      this.driverManagementService.changeDriverFromUnitState(this.unitId);
    }
  }

  ngOnInit(): void {
    this.driver$ = this.driverManagementService.currentDriver$;
    this.isDriverAvailable = this.permissionsSecurityService.isAllowed(FeatureKey.DRIVERS);
    this.isDriverEditAvailable = this.permissionsSecurityService.isAllowed(FeatureKey.DRIVERS_EDIT);
    this.isDriverAssignAvailable = this.permissionsSecurityService.isAllowed(FeatureKey.DRIVER_ASSIGN);
  }

  public editDriver(): void {
    this.driverManagementService.editDriver();
  }

  public removeDriver(): void {
    this.driverManagementService.removeDriver();
  }

  public assignDriver(): void {
    this.driverManagementService.openAssignDriverTable();
  }
}
